import React, { useEffect } from "react";
import { useApi } from "../../utils/api";
import { useParams } from "react-router-dom";
import Loading from "../Layout/Loading";

const CoachingConnectedAccountReturn = () => {
  const { getAccount } = useApi();
  const { accountId } = useParams();
  useEffect(() => {
    const checkAccount = async () => {
      const account = await getAccount(accountId);
      if (account) {
        const requirements = account?.requirements ?? {};
        const hasNoOpenIssues =
          account.details_submitted &&
          (requirements.currently_due?.length ?? 0) === 0 &&
          !requirements.disabled_reason &&
          account.charges_enabled &&
          account.payouts_enabled;
        if (hasNoOpenIssues) {
          sessionStorage.setItem("stripeOnboardingComplete", "1");
        }
      }
      window.location.href = "/clients";
    };
    checkAccount();
  }, [accountId, getAccount]);
  return <Loading style={{ m: 4 }} />;
};

export default CoachingConnectedAccountReturn;
